import useSWR from "swr";
import { fetcher } from "../config/axiosConfig.ts";
import { BaseUrl, swrOptions } from "../const.ts";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import { IEventDetail } from "../model.ts";

export const useDetail = () => {
  const { detailviewid } = useParams();
  const url = Cookies.get("access") ? "api/v1/events" : "admin";
  const { data, error, isLoading } = useSWR<{
    code: number;
    body: IEventDetail;
    message: string;
  }>(`${BaseUrl}/events-ms/${url}/${detailviewid}`, fetcher, swrOptions);
  return {
    data: data?.body,
    error,
    isLoading,
  };
};
